<p-card>
  <ng-template #title>{{ file().file?.filename }}</ng-template>
  <ng-template #subtitle>{{ ('analytics.documentTypes.' + file().documentType) | translate }}</ng-template>

  <div class="grid grid-cols-1 sm:grid-cols-6 gap-6">

    <!-- Document thumbnail — GCS-backed via /image endpoint, or placeholder -->
    @if (imageUrl()) {
      <img [src]="imageUrl()" alt="" class="w-full col-span-2 object-contain rounded" />
    } @else {
      <div class="col-span-2 flex items-center justify-center rounded bg-surface-100 dark:bg-surface-800 min-h-24">
        <i class="fa-solid fa-file-image text-2xl text-surface-400"></i>
      </div>
    }

    <!-- StrengthTestResult fields -->
    @if (file().documentType === 'StrengthTestResult') {
      <div class="col-span-2">
        <!-- SAMPLE METADATA -->
        <ul class="main-list mb-4">
          <li>{{ 'analytics.labels.sampleId' | translate }}:
            <span [class]="getConfidenceColor(file().outputFiltered.sampleId?.confidence)">{{ file().outputFiltered.sampleId?.value }}</span>
          </li>
          <li>{{ 'analytics.labels.sampleDate' | translate }}:
            <span [class]="getConfidenceColor(file().outputFiltered.sampleDate?.confidence)">{{ file().outputFiltered.sampleDate?.value || 'N/A' }}</span>
          </li>
          <li>{{ 'analytics.labels.sampleType' | translate }}:
            <span [class]="getConfidenceColor(file().outputFiltered.sampleType?.confidence)">{{ ('analytics.sampleType.' + file().outputFiltered.sampleType?.value) | translate }}</span>
          </li>
        </ul>
        <!-- CONCRETE DATA -->
        <div>
          <span class="font-bold mt-4">{{ 'analytics.labels.concrete' | translate }}:</span>
          <ul class="children-list">
            @for (child of file().outputFiltered.concrete | keyvalue; track child.key) {
              <li>{{ ('analytics.labels.' + $any(child.key)) | translate }}: <span [class]="getConfidenceColor(child.value.confidence)">{{ child.value.value }}</span></li>
            }
          </ul>
        </div>
      </div>
      <!-- STRENGTH RESULTS TABLE -->
      <div class="col-span-2">
        <p class="font-bold">{{ 'analytics.labels.strengthTestResult' | translate }}</p>
        <p-table [value]="file().outputFiltered.strengthTestResult" class="w-full" size="small" [showGridlines]="true">
          <ng-template #header>
            <tr>
              @for (prop of file().outputFiltered.strengthTestResult[0] | keyvalue; track prop.key) {
                <th>{{ ('analytics.labels.' + $any(prop.key)) | translate }}</th>
              }
            </tr>
          </ng-template>
          <ng-template #body let-item>
            <tr>
              @for (prop of item | keyvalue; track prop.key) {
                <td [class]="getConfidenceColor(prop.value.confidence)">{{ prop.value.value }}</td>
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
    }

    <!-- DeliveryNote fields -->
    @if (file().documentType === 'DeliveryNote') {
      <div class="col-span-4">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-3">
          <div>
            <span class="text-surface-500 text-sm">{{ 'analytics.deliveryNote.labels.deliveryNoteId' | translate }}</span>
            <p [class]="getConfidenceColor(file().outputFiltered.deliveryNoteId?.confidence)">{{ file().outputFiltered.deliveryNoteId?.value ?? '—' }}</p>
          </div>
          <div>
            <span class="text-surface-500 text-sm">{{ 'analytics.deliveryNote.labels.manufacturingDate' | translate }}</span>
            <p [class]="getConfidenceColor(file().outputFiltered.manufacturingDate?.confidence)">{{ file().outputFiltered.manufacturingDate?.value ?? '—' }}</p>
          </div>
          <div>
            <span class="text-surface-500 text-sm">{{ 'analytics.deliveryNote.labels.manufacturingTime' | translate }}</span>
            <p [class]="getConfidenceColor(file().outputFiltered.manufacturingTime?.confidence)">{{ file().outputFiltered.manufacturingTime?.value ?? '—' }}</p>
          </div>
          <div>
            <span class="text-surface-500 text-sm">{{ 'analytics.deliveryNote.labels.volume' | translate }}</span>
            <p [class]="getConfidenceColor(file().outputFiltered.volume?.confidence)">{{ file().outputFiltered.volume?.value ?? '—' }}</p>
          </div>
          <div>
            <span class="text-surface-500 text-sm">{{ 'analytics.deliveryNote.labels.truckLicensePlate' | translate }}</span>
            <p [class]="getConfidenceColor(file().outputFiltered.truckLicensePlate?.confidence)">{{ file().outputFiltered.truckLicensePlate?.value ?? '—' }}</p>
          </div>
          <div>
            <span class="text-surface-500 text-sm">{{ 'analytics.deliveryNote.labels.concreteType' | translate }}</span>
            <p [class]="getConfidenceColor(file().outputFiltered.concreteMetadata?.concreteType?.confidence)">{{ file().outputFiltered.concreteMetadata?.concreteType?.value ?? '—' }}</p>
          </div>
          <div>
            <span class="text-surface-500 text-sm">{{ 'analytics.deliveryNote.labels.cementContent' | translate }}</span>
            <p [class]="getConfidenceColor(file().outputFiltered.concreteMetadata?.cementContent?.confidence)">{{ file().outputFiltered.concreteMetadata?.cementContent?.value ?? '—' }}</p>
          </div>
          <div>
            <span class="text-surface-500 text-sm">{{ 'analytics.deliveryNote.labels.waterCementRatio' | translate }}</span>
            <p [class]="getConfidenceColor(file().outputFiltered.concreteMetadata?.waterCementRatio?.confidence)">{{ file().outputFiltered.concreteMetadata?.waterCementRatio?.value ?? '—' }}</p>
          </div>
        </div>
        @if (file().outputFiltered.mixer?.mixer_name?.value) {
          <p class="text-sm"><span class="text-surface-500">{{ 'analytics.deliveryNote.labels.mixerName' | translate }}:</span>
            <span class="ml-1" [class]="getConfidenceColor(file().outputFiltered.mixer?.mixer_name?.confidence)">{{ file().outputFiltered.mixer.mixer_name.value }}</span>
          </p>
        }
      </div>
    }

  </div>

  <ng-template #footer>
    <button pButton [routerLink]="['../documents/', file()._id]">{{ 'analytics.button.reviewResults' | translate }}</button>
  </ng-template>
</p-card>
